import React, { useState } from 'react';
import { createProject } from './api';

function ProjectsHome({ theme, projects, onRefresh, onOpen }) {
  const [showForm, setShowForm] = useState(false);
  const [name, setName] = useState('');
  const [agentId, setAgentId] = useState('');
  const [defaultTag, setDefaultTag] = useState('whatsapp');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const inputStyle = {
    width: '100%',
    padding: '11px 12px',
    backgroundColor: theme.inputBg,
    border: `1px solid ${theme.inputBorder}`,
    borderRadius: 10,
    color: theme.text,
    fontSize: 14,
    outline: 'none',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const project = await createProject({ name, agentId, defaultTag });
      setName('');
      setAgentId('');
      setDefaultTag('whatsapp');
      setShowForm(false);
      await onRefresh();
      onOpen(project);
    } catch (err) {
      setError(err.message || 'Could not create project');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          gap: 16,
          marginBottom: 28,
          flexWrap: 'wrap',
        }}
      >
        <div>
          <h1
            style={{
              margin: 0,
              fontSize: 28,
              fontWeight: 600,
              letterSpacing: '-0.03em',
              color: theme.text,
            }}
          >
            Projects
          </h1>
          <p style={{ margin: '8px 0 0', color: theme.textMuted, fontSize: 15, maxWidth: 520 }}>
            Create a campaign, upload contacts, and generate unique ElevenLabs survey links.
          </p>
        </div>
        <button
          type="button"
          onClick={() => setShowForm((v) => !v)}
          style={{
            padding: '12px 18px',
            backgroundColor: theme.accent,
            color: '#fff',
            border: 'none',
            borderRadius: 10,
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          {showForm ? 'Cancel' : 'New project'}
        </button>
      </div>

      {showForm && (
        <form
          onSubmit={handleCreate}
          style={{
            backgroundColor: theme.surface,
            border: `1px solid ${theme.border}`,
            borderRadius: theme.radius,
            padding: 24,
            marginBottom: 24,
            boxShadow: theme.shadow,
          }}
        >
          <div style={{ display: 'grid', gap: 14, maxWidth: 520 }}>
            <div>
              <label style={{ display: 'block', fontSize: 13, color: theme.textMuted, marginBottom: 6 }}>
                Project name
              </label>
              <input
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Colombia WhatsApp Survey"
                style={inputStyle}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 13, color: theme.textMuted, marginBottom: 6 }}>
                ElevenLabs agent ID
              </label>
              <input
                required
                value={agentId}
                onChange={(e) => setAgentId(e.target.value)}
                placeholder="agent_..."
                style={inputStyle}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 13, color: theme.textMuted, marginBottom: 6 }}>
                Default tag
              </label>
              <input
                value={defaultTag}
                onChange={(e) => setDefaultTag(e.target.value)}
                placeholder="whatsapp"
                style={inputStyle}
              />
            </div>
            {error && <p style={{ color: theme.danger, fontSize: 13, margin: 0 }}>{error}</p>}
            <button
              type="submit"
              disabled={busy}
              style={{
                padding: '12px 18px',
                backgroundColor: busy ? theme.surfaceMuted : theme.accent,
                color: busy ? theme.textFaint : '#fff',
                border: 'none',
                borderRadius: 10,
                fontSize: 14,
                fontWeight: 600,
                cursor: busy ? 'not-allowed' : 'pointer',
                width: 'fit-content',
              }}
            >
              {busy ? 'Creating...' : 'Create project'}
            </button>
          </div>
        </form>
      )}

      {projects.length === 0 ? (
        <div
          style={{
            backgroundColor: theme.surface,
            border: `1px solid ${theme.border}`,
            borderRadius: theme.radius,
            padding: 40,
            textAlign: 'center',
            color: theme.textMuted,
          }}
        >
          No projects yet. Create one to start generating links.
        </div>
      ) : (
        <div style={{ display: 'grid', gap: 12 }}>
          {projects.map((p) => (
            <button
              key={p.slug}
              type="button"
              onClick={() => onOpen(p)}
              style={{
                textAlign: 'left',
                backgroundColor: theme.surface,
                border: `1px solid ${theme.border}`,
                borderRadius: theme.radius,
                padding: '18px 20px',
                cursor: 'pointer',
                boxShadow: theme.shadow,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 16,
                color: theme.text,
                fontFamily: 'inherit',
              }}
            >
              <div>
                <div style={{ fontSize: 17, fontWeight: 600 }}>{p.name}</div>
                <div style={{ fontSize: 13, color: theme.textMuted, marginTop: 4 }}>
                  /{p.slug} · {p.linkCount} link{p.linkCount === 1 ? '' : 's'}
                </div>
              </div>
              <span style={{ color: theme.accent, fontSize: 14, fontWeight: 600 }}>Open</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default ProjectsHome;
